'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIn = require('./getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _setIn = require('./setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (keyPath, updater) {
    return function (parcelData) {
        return (0, _pipeWith2.default)(parcelData, (0, _setIn2.default)(keyPath, updater((0, _pipeWith2.default)(parcelData, (0, _getIn2.default)(keyPath)))));
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/updateIn.js
// module id = 759
// module chunks = 35783957827783